import React, { useContext, useEffect, useState } from "react";

import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import Typography from "@mui/material/Typography";
import { DialogContentText } from "@mui/material";
import Grid from "@mui/material/Grid";

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";

import content from "../../services/content";

import DialogTitle from "@mui/material/DialogTitle";
import config from "../../config";
import DialogContent from "@mui/material/DialogContent";

import Dialog from "@mui/material/Dialog";
import useMediaQuery from "@mui/material/useMediaQuery";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Iframe from "../Iframe";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const useStyles = makeStyles((theme) => ({
  titleIcon: {
    height: theme.spacing(3),
    marginTop: theme.spacing(0.5),
    marginRight: "-0.6rem",
  },
  title: {
    marginBottom: theme.spacing(-1),
  },
  actions: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(-1),
  },
  closeButton: {
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(1),
  },
  body: {
    color: "black",
    padding: "0.5rem 2rem",
  },
  titleText: {
    marginLeft: theme.spacing(1),
    fontWeight: "bold",
    textAlign: "center",
  },
  button: {
    padding: "0.8rem 0",
  },
  iframeContainer: {
    overflow: "hidden",
    paddingBottom: "56.25%",
    position: "relative",
    height: "0",
    width: "100%",
  },
}));

export default function WelcomeDialog(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);
  const [videoKey, setVideoKey] = useState("howToUse.video.");
  const [video, setVideo] = useState(content["howToUse.video"]["maharashtra"]);

  const theme = useTheme();
  const isLessThanSmall = useMediaQuery(theme.breakpoints.down('md'));
  const fullScreen = isLessThanSmall;

  useEffect(() => {
    if (props.userState) {
      setVideo(
        content["howToUse.video"][props.userState.name_en.toLowerCase()]
      );
      setVideoKey(videoKey + props.userState.name_en.toLowerCase());
    } else {
      setVideo(content["howToUse.video"]["maharashtra"]);
      setVideoKey(videoKey + "maharashtra");
    }
  }, [props.userState]);

  return <>
    <Dialog
      fullWidth={true}
      onClose={props.handleClose}
      aria-labelledby="title"
      open={props.open}
    >
      <div className={classes.iframeContainer}>
        <Iframe src={video?.video} />
      </div>
      <DialogTitle className={classes.title}>
        {/* <Grid container direction="row" justify="center" alignItems="center">
          <Grid item xs={2}>
            <img
              className={classes.titleIcon}
              src={`${config.appUrl}/icons/namaste.png`}
              alt=""
            />
            </Grid>
            <Grid item xs={8}>
            <Typography
              gutterBottom
              variant="h6"
              className={classes.titleText}
            > */}
        {/* {messages["dashboard.welcomeMessage.title"][language]} */}
        {/* अग्रोस्टार गोल्ड मध्ये आपले स्वागत आहे
            </Typography>
          </Grid> */}
        {/* <Grid item xs={2}>
            <IconButton
              edge="end"
              aria-label="close"
              onClick={props.handleClose}
              className={classes.closeButton}
              color="inherit"
            >
              <Close />
            </IconButton>
          </Grid> */}
        {/* </Grid> */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "baseline",
          }}
        >
          <img
            className={classes.titleIcon}
            src={`${config.appUrl}/icons/namaste.png`}
            alt=""
          />
          <Typography gutterBottom variant="h6" className={classes.titleText}>
            {/* {messages["dashboard.welcomeMessage.title"][language]} */}
            अग्रोस्टार गोल्ड मध्ये आपले स्वागत आहे
          </Typography>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.body}>
          <Typography variant={"body1"} align={"center"}>
            {messages["dashboard.welcomeMessage.body"][language]}
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item xs={11}>
            <Button
              onClick={props.handleWelcome}
              variant={"contained"}
              color="primary"
              fullWidth={true}
              className={classes.button}
              endIcon={<ArrowForwardIcon />}
            >
              {messages["dashboard.welcomeMessage.howToUse"][language]}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  </>;
}
